import {useSelector} from 'react-redux';

import BadgesGrid from '@/components/BadgesGrid/BadgesGrid';
import {BADGE_TRACKING} from '@/consts/badgeTracking';
import useBadgeDetailRoute from '@/hooks/useBadgeDetailRoute';
import {trackBadgeClicked} from '@/services/events/loyaltyEventTracking';
import {selectInProgressBadges} from '@/state/selectors/loyalty';
import type {BadgesInProgressCollectionSectionContentModel} from '@/types/aem';
import type {Badge} from '@/types/loyalty';

type BadgesInProgressCollectionSectionProps = {
    content?: BadgesInProgressCollectionSectionContentModel | null;
};

const BadgesInProgressCollectionSection = ({content}: BadgesInProgressCollectionSectionProps) => {
    const inProgressBadges = useSelector(selectInProgressBadges);
    const {actionsRemainingPluralForms} = content ?? {};
    const {openBadge} = useBadgeDetailRoute();

    const handleBadgeClick = (badge: Badge) => {
        trackBadgeClicked(badge.title, BADGE_TRACKING.PAGE_IDS.BADGES_IN_PROGRESS);
        openBadge(badge);
    };

    return (
        <BadgesGrid
            className='mt-2 px-4'
            badges={inProgressBadges}
            showProgress
            actionsRemainingPluralForms={actionsRemainingPluralForms ?? undefined}
            onBadgeClick={handleBadgeClick}
        />
    );
};

export default BadgesInProgressCollectionSection;
